import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from 'react-bootstrap';
import { DataManager } from '../../../core/data-manager';
import { prepareCustomerOrderTemplateData } from '../../utils/prepareTemplateData';
import PrintDocxButton from '../../utils/PrintDocxButton';



export default function DGLTH_customer_order({ item, entity = null }) {

    const navigate = useNavigate();


    function sendEmail() {
        navigate('/page/SendDocumentEmailCustomerOrder?id=' + item.id + '&e=customer_order')
    }

    async function loadPrintData() {
        const res = await DataManager.getItem('customer_order', item.id);
        if (res.success !== 1) return null;
        const data = res.body[0];
        return {
            fileDocument: data.fileDocument,
            templateData: prepareCustomerOrderTemplateData(data),
            filename: 'ordine_' + data.internalCode,
            entity: 'customer_order',
            id: item.id
        };
    }


    return (
        <>
            <PrintDocxButton
                templateKey="template_order_customer"
                loadData={loadPrintData}
            />
            <Button size='sm' variant='outline-primary' className='me-1' onClick={() => sendEmail()}>Invia email</Button>
        </>
    )
};
